module.exports = __webpack_public_path__ + "img/stock2.1f3d5dac.png";